/** The For each element: a bounded loop over a list. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Runs `steps` once per item of a list; the validator bounds `maxItems` by `WORKFLOW_LIMITS.maxLoopItems`. */
export const FOR_EACH_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.ForEach,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.None,
    title: 'For each',
    icon: 'fa-repeat',
    fields: [
        {
            bind: 'items',
            required: true,
            renderer: WorkflowFieldRenderer.Binding,
            metadata: {
                displayName: 'Items',
                type: MetadataEntityFieldType.Custom,
                // A list: the binding picker offers only list values here.
                arrayOf: MetadataEntityFieldType.Custom,
            },
        },
        {
            bind: 'maxItems',
            required: true,
            bindable: false,
            metadata: {
                displayName: 'At most',
                type: MetadataEntityFieldType.Number,
                min: 1,
            },
        },
    ],
    outputs: [],
    branches: [
        { prop: 'steps', title: 'For each item' },
    ],
};
